<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Upload"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Branch" :required="true">
              <b-form-select
                @blur="$v.customers.branch_id.$touch"
                :class="{ 'is-invalid': $v.customers.branch_id.$error }"
                v-model="customers.branch_id"
                :options="branches"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.customers.branch_id.required"
              >
                Please select branch
              </div>
            </form-group>

            <form-group label="File">
              <small>csv file from Rapid</small><br />
              <file-upload
                @files-uploaded="
                  selectedFile = $event;
                  fileUploading = false;
                "
                @files-uploaded-started="fileUploading = true"
                :multiple="false"
                accepted-types=".csv"
              />
            </form-group>

            <b-spinner label="Spinning" v-if="loading"></b-spinner>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import customerRepo from "@/api/repos/customerRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import fileUpload from "@/components/common/FileUpload";

export default {
  components: {
    formBase,
    formGroup,
    fileUpload,
  },

  validations: {
    customers: {
      branch_id: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      customers: {},
      branches: [],
      selectedFile: [],
      fileUploading: false,
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await customerRepo.createGetData();
        this.branches = data.branches;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          if (this.fileUploading) {
            alert("file uploading...");
            this.loading = false;
            this.submitStatus = null;
          } else {
            if (this.selectedFile.length == 0) {
              this.loading = false;
              this.submitStatus = null;
              return alert("Please upload file");
            }

             this.customers.file_id = this.selectedFile;

            await customerRepo.upload(this.customers);
            this.$emit("customerCreated");

            this.$root.$bvToast.toast("Success", {
              title: "Uploaded Successfully",
              autoHideDelay: 3000,
              variant: "success",
            });
          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

